export default {
  setup: function() {
    require('navigator.sendbeacon');
  },
};
